export function passwordValidationError(value) {
  if (typeof value !== 'string' || value.length < 8) return 'A senha deve ter ao menos 8 caracteres.';
  if (new TextEncoder().encode(value).length > 72) return 'Essa senha é muito longa. Use uma senha mais curta.';
  return null;
}
